import transakSDK from "@transak/transak-sdk";

// https://global.transak.com/?
// apiKey=
// cryptoCurrencyCode=AUSDC&
// walletAddress=
// network=polygon&
// hideExchangeScreen=true&
// disableWalletAddressForm=true&
// exchangeScreenTitle=Add+funds+to+your+Cask+Wallet&
// isDisableCrypto=true
// http://localhost:3000/?apiKey=3758451a-36b9-4f92-a8a5-192bdf9d76de&symbol=APOLDAI&network=polygon&partnerOrderId=sandeep_1
export const launchTransak = (params) => {
  const { apiKey, environment, defaultCryptoCurrency, walletAddress, fiatCurrency, partnerOrderId, email } = params;

  console.log("launching transak");
  let transak = new transakSDK({
    widgetHeight: "750px",
    widgetWidth: "450px",
    fiatCurrency, // If you want to limit fiat selection eg 'GBP'
    apiKey, // Your API Key
    environment, // STAGING/PRODUCTION
    defaultCryptoCurrency,
    email,
    walletAddress,
    partnerOrderId,
    disableWalletAddressForm: true,
    // Need to add transakone params and other needed params
  });

  return transak;
};
